import "./GiveAway.css";

const GiveAway = () => {
  return (
    <div className="about-epow-page-n">
      <div className="gradient-bg-circle gradient-bg-circle-222"></div>
      <div className="container">
        <div className="about-epow giveaway-page">
          <h1 className="">
            Giveaway announcement
            <br />
          </h1>{" "}
          <div className="giveaway-alert-p">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Incidunt, aliquam? Aliquid praesentium cumque delectus, nulla
              eveniet perferendis quis nobis recusandae quam distinctio fuga
              facilis magni minus illum veritatis! Laudantium, amet!
            </p>
          </div>
          <div className="card-colors">
            <div className="card-detail carrd--1">
              <div className="card-outer-noise">
                <div className="card-noise"></div>
              </div>
              <div className="icon-box">
                <div className="shape"></div>
                <div className="icon">
                  1{/* <i className="fa-solid fa-bolt-lightning"></i> */}
                </div>
              </div>
              <div className="card-txt ct-1">
                1st Reward
                <br />
                <span className="bling-text--span">$2,500</span>
              </div>
            </div>
            <div className="card-detail carrd--2">
              <div className="card-outer-noise">
                <div className="card-noise"></div>
              </div>
              <div className="icon-box">
                <div className="shape shape-2"></div>
                <div className="icon icon-2">
                  2{/* <i className="fa-solid fa-arrow-trend-up"></i> */}
                </div>
              </div>
              <div className="card-txt ct-2">
                2nd Reward
                <br />
                <span className="bling-text--span">$2,000</span>
              </div>
            </div>
            <div className="card-detail carrd--3">
              <div className="card-outer-noise">
                <div className="card-noise"></div>
              </div>
              <div className="icon-box ">
                <div className="shape shape-3"></div>
                <div className="icon icon-3 ">
                  3 {/* <i className="fa-solid fa-medal"></i> */}
                </div>
              </div>
              <div className="card-txt ct-3">
                3rd Reward
                <br />
                <span className="bling-text--span">$1,500</span>
              </div>
            </div>
          </div>
          <div className="card-details-reward">
            <div className="card-reward-numbers">
              <i className="fa-solid fa-medal"></i>
            </div>
            <h6>4th & 5th Reward</h6>
            <span className="bling-text--span">$1,000</span>
          </div>
          <div className="card-details-reward">
            <div className="card-reward-numbers">
              <i className="fa-solid fa-medal"></i>
            </div>
            <h6>6th to 10th Rewards</h6>
            <span className="bling-text--span">$500</span>
          </div>{" "}
          <div className="card-details-reward">
            <div className="card-reward-numbers">
              <i className="fa-solid fa-medal"></i>
            </div>
            <h6>The Next 5 Rewards</h6>
            <span className="bling-text--span">$300</span>
          </div>
          <br />{" "}
          <div className="about-epow-steps-to-win">
            <h2>Win in three easy steps</h2>
            <div className="about-epow-steps-steps">
              <div className="container">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="steps---to-step">
                      <div className="step-1-epow">1</div>
                      <div className="step-div-epow">
                        <div>
                          <i className="fa fa-user fa-lg"></i>
                        </div>
                        <div>
                          <h4>Follow</h4>
                        </div>{" "}
                        <div>
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Sed maiores unde ut animi voluptatibus non
                            natus nesciunt laboriosam impedit voluptatem.
                          </p>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    {" "}
                    <div className="steps---to-step">
                      <div className="step-1-epow">2</div>
                      <div className="step-div-epow">
                        <div>
                          <i className="fa fa-heart fa-lg"></i>
                        </div>
                        <div>
                          <h4>Follow</h4>
                        </div>{" "}
                        <div>
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Sed maiores unde ut animi voluptatibus non
                            natus nesciunt laboriosam impedit voluptatem.
                          </p>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    {" "}
                    <div className="steps---to-step">
                      <div className="step-1-epow">3</div>
                      <div className="step-div-epow">
                        <div>
                          <i className="fa fa-share fa-lg"></i>
                        </div>
                        <div>
                          <h4>Follow</h4>
                        </div>{" "}
                        <div>
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Sed maiores unde ut animi voluptatibus non
                            natus nesciunt laboriosam impedit voluptatem.
                          </p>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />{" "}
          <div className="more-info-rewards">
            <h2>Win in three easy steps</h2>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
              autem voluptates fuga voluptate, totam sint ad placeat libero
              asperiores dolore, nihil iure enim officia. Omnis cum voluptas
              error excepturi tempore.Lorem ipsum, dolor sit amet consectetur
              adipisicing elit. Dicta autem voluptates fuga voluptate, totam
              sint ad placeat libero asperiores dolore, nihil iure enim officia.
              Omnis cum voluptas error excepturi tempore.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiveAway;
